$(document).ready(function() {

    // OFI
    objectFitImages();

    /*
        GLOBAL
     */
    $(".fancybox").fancybox();

    if ($('.testimonials-block').length > 0) {
        $('.testimonials-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["Avis précédent", "Avis suivant"],
            dots: false,
            autoplay: false,
            margin: 30,
            lazyLoad: true,
            responsive: {
                768: {
                    items: 2
                }
            }
        });
    }

    $('header#header #bottom-part #main-menu>.navbar-nav .nav-item').on('mouseenter', function() {
        $('header#header #bottom-part #main-menu #megamenu').addClass('active');

        const submenu_id = $(this).data('submenu-id');

        $('header#header #bottom-part #main-menu #megamenu .submenu.active').removeClass('active');
        $('header#header #bottom-part #main-menu #megamenu .submenu[data-submenu-id="'+submenu_id+'"]').addClass('active');
    });

    $('header#header #bottom-part #main-menu>.navbar-nav .nav-item').on('mouseleave', function(e) {

        if ($(e.relatedTarget).attr('id') != 'megamenu' && !$(e.relatedTarget).hasClass('submenu')) {
            $('header#header #bottom-part #main-menu #megamenu').removeClass('active');
            $('header#header #bottom-part #main-menu #megamenu .submenu.active .subsubmenu-item.active').removeClass('active');
            $('header#header #bottom-part #main-menu #megamenu .submenu.active').removeClass('active');
        }
    });


    $('header#header #bottom-part #main-menu #megamenu .submenu .submenu-items .submenu-item').on('mouseenter', function() {
        const subsubmenu_id = $(this).data('subsubmenu-id');

        $(this).closest('.submenu').find('.subsubmenu-item.active').removeClass('active');
        $(this).closest('.submenu').find('.subsubmenu-item[data-subsubmenu-id="'+subsubmenu_id+'"]').addClass('active');
    });


    $('header#header #bottom-part #main-menu #megamenu').on('mouseleave', function() {
        $(this).removeClass('active');
        $(this).find('.submenu.active .subsubmenu-item.active').removeClass('active');
        $(this).find('.submenu.active').removeClass('active');
    });

    $(document).on('click', '.video-text-block .content-wrapper .btn-extrait', function() {
       const isPlaying = $(this).hasClass('is-playing');

       if (isPlaying) {
           $(this).closest('.video-text-block').find('.extrait-audio-wrapper audio')[0].pause();
           $(this).removeClass('is-playing');
       } else {
           $(this).closest('.video-text-block').find('.extrait-audio-wrapper audio')[0].play();
           $(this).addClass('is-playing');
       }

        return false;
    });
});
